<section class="container-fluid px-5 py-4">
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>
                <h4 class="text-white">Wizard de Proyecto</h4>
                <h6 class="text-secondary">Etapas para agregar anexos del proyecto</h6>
            </div>      
            <div class="d-flex justify-content-center align-items-center">
      
                <button
                  class="badge rounded-pill btn btn-outline-light"
                  [routerLink]="'/pdg/project/list'"
                >
                  <i
                    class="fa-solid fa-right-from-bracket m-2 fs-6"
                    aria-hidden="true"
                  ></i>
                  <span class="m-2 fs-6">Volver al listado de proyectos</span>
                </button>
    
              </div>
        </div>
    </header>
    
</section>
<section class="container-fluid px-5 ">
<div class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:250px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center ">
        <div>
            <h5 class="ms-3">Configuracion de pagos: - {{nameproject}}</h5>
        </div>
    </div>
    <div *ngIf="state == 0" class="componente-importantes text-start px-5 mt-3" style="min-height:700px ;" >
        <section class="row">
            <form
                action=""
                method="post"
                (submit)="formSubmit()"
                [formGroup]="Paymentsform"
                >
            <div class="col">
            <div>
                <h5 class="ms-3">Seleccione un tipo de configuración de pagos</h5>
            </div>
            <div class="p-3 mx-5 form-check d-flex justify-content-between">
                <div *ngFor="let item of listtype">
                <input class="form-check-input" formControlName="tipo_pago" value="{{item.id}}" type="radio" name="tipo_pago" id="{{item.id}}">
                <span >
                    <label class="form-check-label" [for]="item.id">
                      {{item.name}}
                    </label>
                </span>
                
                </div>
                
            </div>
            </div>
             <section class="row  ">
            <div class="col-12 col-lg-6 col-xxl-3 d-flex justify-content-center justify-content-lg-start m-3">
                <div>
                    <label for="formControlInput" class="form-label mt-5 ">Tipo de moneda</label>
                    <select  required class="custom-outline-input form-select mt-3"  (change)="actionSelectType()" formControlName="tipo_moneda" >
                    <option selected value="" > Seleccione...</option>
                    <option *ngFor="let item of listmonedas" [value]="item.id" >{{item.name}}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-3 d-flex justify-content-center justify-content-lg-start  m-3">
                <div>
                    <label for="formControlInput" class="form-label mt-5 ">Monto total</label>
                    <input required type="text" placeholder="Ingrese información" formControlName="total" class="custom-outline-input mt-3" id="formControlInput"  (blur)="transformAmount($event)">
                </div> 
            </div>
            <div class="col-12 col-lg-6 col-xxl-3 d-flex justify-content-center justify-content-lg-start  m-3">
                <div>
                    <label for="formControlInput" class="form-label mt-5 ">Anexo de contrato</label>
                    <select class="custom-outline-input form-select mt-3"  formControlName="anexo">
                    <option selected value="" > Seleccione...</option>
                    <option *ngFor="let item of listanex" [value]="item.id" >{{item.name}}</option>
                    </select>
                </div>
                
            </div>
            <footer class="row mt-5 pb-3">
            <div class="col-12 d-flex justify-content-end">
                <button [disabled]="!Paymentsform.valid" type="submit" class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk" aria-hidden="true"></i>  Guardar datos</button>
            </div>
        </footer>
        </section>
            </form>
        </section>
        
        
    </div>
    <app-pago1plus1 *ngIf="state == 2" [pagos]="respuesta" ></app-pago1plus1>
    <app-multiplespagos *ngIf="state == 6" [pagos]="respuesta" ></app-multiplespagos>
    <app-ejecucion *ngIf="state == 4" [pagos]="respuesta" ></app-ejecucion>
    <app-pagosperso *ngIf="state == 1" [pagos]="respuesta" ></app-pagosperso>
</div>
</section>